import { NgModule } from '@angular/core';
import { I18nLoaderService } from './i18n-loader.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        TranslateModule.forRoot(),
    ],
    providers: [I18nLoaderService],
})
export class I18nLoaderModule { }
